export const EPSG4545 = {
  name: "EPSG:4545",
  proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
  wkt: "CGCS2000_3_Degree_GK_CM_108E",
}